import axios from 'axios';
import store from '@/store';

export const get = async (route) => await makeRequest('get', route);
export const getBlob = async (route) => await makeRequest('get', route, null, false, { isBlob: true });
export const post = async (route, data) => await makeRequest('post', route, data);
export const postFormData = async (route, data) => await makeRequest('post', route, data, true);
export const put = async (route, data) => await makeRequest('put', route, data);
export const putFormData = async (route, data) => await makeRequest('put', route, data, true);
export const dlt = async (route) => await makeRequest('delete', route);

const makeRequest = async (method, route, data = null, isFormData = false, options = null) => {
  try {
    const baseUrl = process.env.VUE_APP_API_URL;
    const token = store.getters.userToken;
    const headers = {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
      'Authorization': token,  //I know that this is handled by the interceptor, but I prefer to keep logic in one place. I do not like how logic gets fragmented with interceptors
      'Accept': 'application/json'
    }

    const axiosOptions = { method, headers, baseUrl, data, url: route };
    if (options) {
      if (options.isBlob) axiosOptions.responseType = 'blob';
    }
    const res = await axios(axiosOptions);
    if (res.status === 401) {
      store.dispatch('logout').then(() => location.reload());
    }

    return res.data;
  } catch (e) {
    console.error(e);
    throw e; //let the calling place handle the error in an appropriate way
  }
}

class Api {
  constructor(model, endpoint) {
    this.model = model;
    this.endpoint = endpoint;
  }

  async store(data, url = null, options = {}, errorCallback = null) {
    let res;
    const errorText = `Could not store ${this.model} record`;

    await axios.post(`/${this.endpoint}${url ? `/${url}` : ''}`, data, options)
      .then((response) => {
        res = response.data;
      })
      // eslint-disable-next-line consistent-return
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 510 || error.response.status === 409 || error.response.status === 400) {
            res = {
              status: error.response.status ? error.response.status : 500,
              message: error.response.data ? error.response.data : 'An error occurred while processing the request.',
            };
            return res;
          }
          // Request made and server responded
          console.log('Request made and server responded');
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
        // The request was made but no response was received
          console.log('The request was made but no response was received');
          console.log(error.request);
        } else {
        // Something happened in setting up the request that triggered an Error
          console.log('Something happened in setting up the request that triggered an Error');
          console.log('Error', error.message);
        }

        if (errorCallback) {
          errorCallback(error);
        }

        console.log(errorText);
        res = false;
      });
    return res;
  }

  async get(url = null, options = {}) {
    let res;
    const errorText = `Could not get ${this.model} list`;

    await axios.get(`/${this.endpoint}${url ? `/${url}` : ''}`, options)
      .then((response) => {
        res = response.data;
      })
      .catch((error) => {
        if (error.response) {
        // Request made and server responded
          console.log('Request made and server responded');
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
        // The request was made but no response was received
          console.log('The request was made but no response was received');
          console.log(error.request);
        } else {
        // Something happened in setting up the request that triggered an Error
          console.log('Something happened in setting up the request that triggered an Error');
          console.log('Error', error.message);
        }
        console.log(errorText);
        res = null;
      });
    return res;
  }

  async getList(url = null) {
    let res = [];
    const errorText = `Could not fetch ${this.model} list`;

    await axios.get(`/${this.endpoint}${url ? `/${url}` : ''}`)
      .then((response) => {
        res = response.data;
      })
      .catch((error) => {
        if (error.response) {
        // Request made and server responded
          console.log('Request made and server responded');
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
        // The request was made but no response was received
          console.log('The request was made but no response was received');
          console.log(error.request);
        } else {
        // Something happened in setting up the request that triggered an Error
          console.log('Something happened in setting up the request that triggered an Error');
          console.log('Error', error.message);
        }
        console.log(errorText);
        res = [];
      });
    return res;
  }

  async read(data, options = {}, url = null) {
    let res = [];
    const errorText = `Could not fetch ${this.model} read`;

    await axios.post(`/${this.endpoint}${url ? `/${url}` : '/read'}`, data, options)
      .then((response) => {
        if (!response || !response.data || response.data.length === 0) res = [];
        else { res = response.data; }
      })
      // eslint-disable-next-line consistent-return
      .catch((error) => {
        if (axios.isCancel(error)) {
          const cancelCode = 3001;
          res = cancelCode;
        } else {
          if (error.response) {
            if (error.response.status === 505) {
              res = {
                status: 505,
                message: error.response.data,
              };
              return res;
            }
            // Request made and server responded
            console.log('Request made and server responded');
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
          // The request was made but no response was received
            console.log('The request was made but no response was received');
            console.log(error.request);
          } else {
          // Something happened in setting up the request that triggered an Error
            console.log('Something happened in setting up the request that triggered an Error');
            console.log('Error', error.message);
          }
          console.log(errorText);

          res = [];
        }
      });

    return res;
  }

  async update(data, url = null) {
    let res;
    const errorText = `Could not update ${this.model}`;

    await axios.put(`/${this.endpoint}${url ? `/${url}` : ''}`, data)
      .then((response) => {
        res = response.data;
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 510 || error.response.status === 409 || error.response.status === 400) {
            res = {
              status: error.response.status ? error.response.status : 500,
              message: error.response.data ? error.response.data : 'An error occurred while processing the request.',
            };
            return res;
          }
        // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
        // The request was made but no response was received
          console.log(error.request);
        } else {
        // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        console.log(errorText);
        res = false;
      });
    return res;
  }

  async delete(id) {
    let res;
    const errorText = `Could not delete ${this.model} item`;

    await axios.delete(`/${this.endpoint}/${id}`)
      .then((response) => {
        res = response.data;
      })
      .catch((error) => {
        if (error.response) {
        // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
        // The request was made but no response was received
          console.log(error.request);
        } else {
        // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        console.log(errorText);
        res = false;
      });
    return res;
  }

  async storeFormData(data) {
    let res;
    const errorText = `Could not store ${this.model}`;

    try {
      res = await axios.post(`/${this.endpoint}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (res.status === 200) {
        res = true;
      } else {
        console.error(errorText);
        res = false;
      }
    } catch (e) {
      console.error(errorText);
      console.error(e);
      res = false;
    }

    return res;
  }

  async softDelete(id) {
    let res;
    const errorText = `Could not delete ${this.model}`;

    try {
      res = await axios.delete(`/${this.endpoint}/${id}`);
      if (res.status === 200) {
        res = true;
      } else {
        console.error(errorText);
        res = false;
      }
    } catch (e) {
      console.error(errorText);
      console.error(e);
      res = false;
    }

    return res;
  }
}

export default Api;

